// Full-width push-down mega menu: a header button toggles it via commandfor/command="--toggle".
// Closed panels stay inert so their links leave the tab order; Escape and outside clicks close it.
class SMegaMenu extends HTMLElement {
  #controller = null;
  #source = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.inert = !this.hasAttribute('data-open');

    this.addEventListener('command', (event) => {
      if (event.command !== '--toggle') return;
      this.#source = event.source;
      this.toggle(!this.hasAttribute('data-open'));
    }, { signal });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.hasAttribute('data-open')) {
        this.toggle(false);
        this.#source?.focus();
      }
    }, { signal });

    document.addEventListener('click', (event) => {
      if (!this.hasAttribute('data-open')) return;
      const header = this.closest('header');
      if (header && !header.contains(event.target)) this.toggle(false);
    }, { signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
  }

  toggle(open) {
    this.toggleAttribute('data-open', open);
    this.inert = !open;
    const triggers = document.querySelectorAll(`[commandfor="${this.id}"]`);
    triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', String(open)));
    this.dispatchEvent(new CustomEvent('mega-menu:toggle', { bubbles: true, detail: { open } }));
    // When the header is fixed (homepage overlay), push the page down by the open panel's height.
    const header = this.closest('header');
    if (header && getComputedStyle(header).position === 'fixed') {
      const panelHeight = open ? this.firstElementChild?.scrollHeight ?? 0 : 0;
      document.documentElement.style.setProperty('--mega-offset', `${panelHeight}px`);
    }
  }
}

if (!customElements.get('s-mega-menu')) customElements.define('s-mega-menu', SMegaMenu);
